import React, { type FC } from "react";
import { Skeleton } from "@/components/ui/adapters";
import clsx from "clsx";
import ConversationsItem from "./ConversationItem";

const ConversationsSkeleton: FC<{ isBorder?: boolean }> = ({
  isBorder = false,
}) => {
  return (
    <div
      role="status"
      aria-label="Loading conversations"
      aria-busy
      className={clsx(
        "relative h-full w-full min-h-0 flex-1 overflow-hidden rounded-b-xl bg-white",
        isBorder && "border-t border-t-secondary-light"
      )}
    >
      {Array.from({ length: 10 }, (_, index) => (
        <ConversationsItem key={index} />
      ))}
    </div>
  );
};

// Chat Room Header Skeleton
const ChatRoomHeaderSkeleton: FC = () => {
  return (
    <div className="w-full shrink-0 [&_.animate-pulse]:animate-none">
      <div className="relative flex h-16 items-center px-4 xl:hidden">
        <Skeleton className="size-10 rounded-2xl" />
        <div className="pointer-events-none absolute inset-x-16 flex justify-center">
          <Skeleton className="h-7 w-28 rounded-xl" />
        </div>
        <Skeleton className="ml-auto size-10 rounded-2xl" />
      </div>
      <div className="hidden flex-row items-center justify-between gap-4 px-4 pt-2 xl:flex">
        <div className="flex items-center justify-start gap-4">
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="h-[30px] w-28 rounded-xl" />
        </div>
        <Skeleton className="mt-2 size-9 rounded-full" />
      </div>
    </div>
  );
};

// Filter Skeleton
const FilterSkeleton: FC = () => (
  <div
    role="status"
    aria-label="Loading room filters"
    aria-busy
    className="h-8 w-full shrink-0 overflow-hidden [&_.animate-pulse]:animate-none"
  >
    <div className="flex justify-start items-center px-4 overflow-hidden gap-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className="shrink-0">
          <Skeleton className="rounded-md w-20 h-8" />
        </div>
      ))}
    </div>
  </div>
);

export { ConversationsSkeleton, ChatRoomHeaderSkeleton, FilterSkeleton };
